import { GDTApiErrors } from '@/types';
import {
  componentsLastFixture,
  PuntajesUltimaFecha,
  ResponseDinamics,
  ResponsePartidosRecienVerificados,
  ResponseScoreMyTeam,
  ResponseStatics,
} from '@/types/fieldAssistance';
import { URLs, axiosErrorHandler } from '@/utils';
import axiosGdt, { axiosGdtWithoutCredentials } from '@/utils/axiosGdt';

export const getDinamics = axiosErrorHandler(async (cacheBuster: string) => {
  const response = await axiosGdtWithoutCredentials.get<ResponseDinamics>(
    URLs.AYUDANTE.DINAMICOS + '?v=' + encodeURIComponent(cacheBuster || '')
  );
  return response.data;
}, 'Error al obtener los datos dinámicos de ayudante.');

export const getStatics = axiosErrorHandler(
  async (centralSCN: string | undefined) => {
    const response = await axiosGdtWithoutCredentials.get<ResponseStatics>(
      URLs.AYUDANTE.ESTATICOS + '?v=' + encodeURIComponent(centralSCN || '')
    );
    return response.data;
  },
  'Error al obtener los datos estáticos de ayudante.'
);

export const getHistoric = axiosErrorHandler(
  async (date: number | undefined) => {
    const response = await axiosGdt.get<ResponseScoreMyTeam>(
      `${URLs.AYUDANTE.HISTORICO_DEMENUZADO}?fechaId=${date || ''}`
    );
    return response.data;
  },
  'Error al obtener puntajes históricos de tus jugadores.'
);

export const getHistoricF5 = axiosErrorHandler(
  async (date: number | undefined) => {
    const response = await axiosGdt.get<ResponseScoreMyTeam>(
      `${URLs.AYUDANTE.HISTORICO_DEMENUZADO_F5}?fechaId=${date || ''}`
    );
    return response.data;
  },
  'Error al obtener puntajes históricos de tus jugadores.'
);

export const getScoreLastMatch = axiosErrorHandler(async () => {
  const response = await axiosGdtWithoutCredentials.get<PuntajesUltimaFecha>(
    URLs.AYUDANTE.PUNTAJES_ULTIMA_FECHA
  );
  return response.data;
}, 'Error al obtener el puntajes de la ultima fecha.');

export const getRecentMatchStats = axiosErrorHandler(async () => {
  /* if (process.env.NODE_ENV === 'development') {
    return getRecentMatchStatsFake();
  } */

  const response = await axiosGdt.get<ResponsePartidosRecienVerificados>(
    URLs.AYUDANTE.FICHAS_PARTIDOS_RECIENTES
  );
  return response.data;
}, 'Error al obtener las fichas de partido de la fecha en curso.');

export const getRecentMatchStatsFake = axiosErrorHandler(async () => {
  // 'https://drive.usercontent.google.com/download?id=1-yR3AsDtc3U0H1L4xn7lJUGZrB4TFe4t&export=download'
  // const url = '/public/response-examples/response-ej-fichas-partidos.json';
  const url = '/public/response-examples/response-ej-fichas-partidos-full.json';
  // const url =
  //  '/public/response-examples/response-ej-fichas-partidos-empty.json';
  // const url = URLs.AYUDANTE.FICHAS_PARTIDOS_RECIENTES + '?idVpfForzada=7174';
  const response =
    await axiosGdtWithoutCredentials.get<ResponsePartidosRecienVerificados>(
      url
    );
  return response.data;
}, 'Error al obtener las fichas de partido de la fecha en curso.');

export const getFixtureRequest = axiosErrorHandler(async (order: number) => {
  const response = await axiosGdt.get<
    componentsLastFixture['schemas']['ResponseFixtureAnterior'] | GDTApiErrors
  >(`${URLs.AYUDANTE.FIXTURE}?ordenFecha=${order}`);
  return response.data;
}, 'Error al obtener los datos dinámicos de ayudante.');
